import type { ProjectFormSchema } from '@/features/project/projects/_models/project';
import { useFormContext } from 'react-hook-form';
import type { z } from 'zod';

type FormValues = z.infer<typeof ProjectFormSchema>;
type InitialFormValues = {
  sheetType: FormValues['sheetType'] | null | undefined;
  data: Partial<FormValues['data']>;
};

export const useProjectFormContext = () =>
  useFormContext<InitialFormValues, unknown, FormValues>();
